import {Colors} from "../colors";
import React, {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {TouchableOpacity} from "react-native";
import {AnimatedCheckIcon} from "./AnimatedCheckIcon";
import {RowSpace} from "./_CommonComponents";
import Text from "./Text";

export function CheckBox(props: { text: string, check: boolean, onCheck: () => void }) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <TouchableOpacity style={{
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center"
    }} onPress={props.onCheck}>
        <AnimatedCheckIcon type={"check"} color={colors.get("secondryColor") as string} check={props.check}/>
        <RowSpace/>
        <Text size={14} color={colors.get("lowConText") as string} weight={600}>{props.text}</Text>
        <RowSpace/>
        <RowSpace/>
    </TouchableOpacity>
}
